// extracted by mini-css-extract-plugin
export default {"body":"Preloader_body__F9tp6","box":"Preloader_box__ZcY3G","coin":"Preloader_coin__SxuLx","spin":"Preloader_spin__+rVSN"};